<template>
  <div class="jms-pagination">
    <el-pagination :current-page.sync="defaultPage.currentPage"
                   :background="defaultPage.pageBackground!==undefined?defaultPage.pageBackground:true"
                   :page-size="defaultPage.pageSize"
                   :page-sizes="defaultPage.pageSizes"
                   @size-change="sizeChange"
                   @current-change="currentChange"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="defaultPage.total"></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'JmsTablePage',
  data() {
    return {
      defaultPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 100, // 每页显示多少条
        pageSizes: [10, 20, 30, 40, 50, 100],
        background: true, // 背景颜色
      },
    }
  },
  created() {
    // 初始化分页
    this.pageInit()
  },
  methods: {
    pageInit() {
      this.defaultPage.total = this.$parent.page.total || 0
      this.defaultPage.currentPage = this.$parent.page.current || 1
      this.defaultPage.pageSize = this.$parent.page.size || 100
      this.defaultPage.pageSizes = this.$parent.page.sizes || [
        10,
        20,
        30,
        40,
        50,
        100,
      ]
    },
    // 页大小回调
    sizeChange(val) {
      this.defaultPage.currentPage = 1
      this.defaultPage.pageSize = val
      this.$parent.$emit('size-change', val)
      this.$emit('size-change', val)
    },
    // 页码回调
    currentChange(val) {
      this.$parent.$emit('current-change', val)
      this.$emit('current-change', val)
    },
  },
}
</script>

<style lang="stylus" scoped>

</style>
